export const MODAL_SHOWN_TIMES_LIMIT = 3;
export const MODAL_DISMISS_LIMIT = 1;
export const MODAL_CADENCE_IN_DAYS = 5;
export const MODAL_APPEARANCE_DELAY = 2 * 60 * 1000; // 2 minutes
